import { callFunctionIfExists } from "../../utils/GeneralUtils";
import DropdownOptionWithIcon from "./DropdownOptionWithIcon";
import PopoverDropdownMenu from "./PopoverDropdownMenu";

interface Props {
  credential: any;
  changePassword: any;
  closeWhisper: any;
  removeCredentialDisabled: boolean;
  removeCredential: any;
}

const UserCredentialOptions = ({
  credential,
  changePassword,
  closeWhisper,
  removeCredentialDisabled,
  removeCredential,
}: Props) => {
  return (
    <PopoverDropdownMenu>
      <DropdownOptionWithIcon
        name="Change Password"
        onClick={() => {
          changePassword(credential);
          callFunctionIfExists(closeWhisper);
        }}
        icon="mdi mdi-form-textbox-password"
        disabled={credential?.Provider !== "local"}
      />
      <DropdownOptionWithIcon
        name="Remove Credentials"
        onClick={() => {
          removeCredential(credential);
          callFunctionIfExists(closeWhisper);
        }}
        icon="mdi mdi-delete"
        disabled={removeCredentialDisabled === true}
      />
    </PopoverDropdownMenu>
  );
};

export default UserCredentialOptions;
